const checkin = {
	title: "Check In",
	no_upcoming_course: "No upcoming course",
	certreg_id: "ID",
	duration: "Duration",
	enrolled: "Enrolled",
	students: "Students",
	attendees: "Attendees",
	did_not_meet: "Did not meet",
	did_not_meet_btn: "Did not meet",
	did_not_meet_confirm: "Participant did not meet. Do you want to continue?",
	check_in_btn: "Check In",
	attendance_btn: "Attendance",
	enrol_title: "Check in student: {name}",
	sync_from_certreg: "Sync from XL3 database",
	certreg_user_not_exist: "XL3 database user does not exist.",
	update_enrolemnt_from_certreg_confirm: "Do you want to update the enrolment detail from the XL3 database site?",
};
export default checkin;